@for (segment of segments(); track segment.id; let index = $index) {
  <button
    #segmentButton
    type="button"
    [class]="segmentClasses(index)"
    [disabled]="isSegmentDisabled(index)"
    [attr.tabindex]="index === focusedIndex() ? 0 : -1"
    [attr.aria-pressed]="isActive(index)"
    [attr.aria-label]="segment.icon ? segment.label : null"
    [mibTooltip]="segment.tooltip ?? ''"
    [mibTooltipDisabled]="!segment.tooltip"
    [mibTooltipPosition]="tooltipPosition()"
    [mibTooltipShowDelay]="tooltipShowDelay()"
    (click)="toggle(index)"
    (focus)="focusedIndex.set(index)">
    @if (segment.icon) {
      <svg mib-icon [name]="segment.icon" [class]="iconClass()"></svg>
    } @else {
      {{ segment.label }}
    }
  </button>
}
